import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    HomePageCarouselPromosComponent,
    HomePageCarouselPromosListWrapper,
    HomePageCarouselSingleItem,
    SliderWrapper,
} from './HomePageCarouselPromos.style';
import { range } from 'lodash';
import { CarouselLoader } from 'src/domains/layouts/shared/loaders';
interface HomePageCarouselLoaderPropsType {
    isDot: boolean;
    isHomePage: boolean;
    noOfPlaceholders: number;
}

export const HomePageCarouselLoader = observer(
    'HomePageCarouselLoader',
    (props: HomePageCarouselLoaderPropsType): JSX.Element => {
        return (
            <HomePageCarouselPromosComponent
                isDot={props.isDot}
                isHomePage={props.isHomePage}
            >
                <HomePageCarouselPromosListWrapper data-test='homepage-carousel-wrapper'>
                    <SliderWrapper calcShift={0}>
                        {range(0, props.noOfPlaceholders).map((i) => (
                            <HomePageCarouselSingleItem key={i}>
                                <CarouselLoader />
                            </HomePageCarouselSingleItem>
                        ))}
                    </SliderWrapper>
                </HomePageCarouselPromosListWrapper>
            </HomePageCarouselPromosComponent>
        );
    }
);
